<template>
	<div class="Newscenter">
		<div class="Newscenter-top">
			<img
				:src="require('@/assets/images/newstop.png')"
				class="image-width"
				alt=""
			/>
		</div>
		<div class="Newscenter-mid">
			<div class="Newscenter-mid-img">
				<img
					:src="require('@/assets/images/newscenter-mid.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Newscenter-mid-text">
				<span class="mid-text-left">{{ $t('新闻') }}</span>
				<span>{{ $t('中心') }}</span>
			</div>
		</div>
		<div class="Newscenter-con">
			<div class="new-swipe-self">
				<van-list
					v-model="loading"
					:finished="finished"
					:finished-text="$t('没有更多了')"
					@load="Loaddata"
					offset="300"
				>
					<div
						class="swipe-self-item"
						v-for="(item, index) in newsList"
						:key="index"
					>
						<div class="self-item-con">
							<div class="item-con-img" @click="Lookdetail(item)">
								<img :src="item.newsImg" class="image-width" alt="" />
							</div>
							<div class="item-con-bom">
								<div class="con-bom-lef">
									<div class="bom-lef-one">
										<div class="lef-one-img">
											<img
												:src="require('@/assets/images/circletime.png')"
												class="image-width"
												alt=""
											/>
										</div>
										<div class="lef-one-text">{{ item.newsDate }}</div>
									</div>
									<div class="bom-lef-two">{{ item.newsContentTitle }}</div>
								</div>
								<div class="con-bom-rig">
									<div class="bom-rig-btn" @click="Lookdetail(item)">
										<div class="rig-btn-text">{{ $t('查看详情') }}</div>
										<div class="rig-btn-img">
											<img
												:src="require('@/assets/images/arrowcircle.png')"
												class="image-width"
												alt=""
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</van-list>
			</div>
		</div>
	</div>
</template>

<script>
import { getNewsList } from '@/api';

export default {
	data() {
		return {
			newsList: [],
			loading: false,
			finished: false,
			pageNum: 1,
			totalpagenum: ''
		};
	},
	created() {},
	methods: {
		Loaddata() {
			// 异步更新数据
			// setTimeout 仅做示例，真实场景中一般为 ajax 请求
			this.newsListFZ();
		},
		//新闻内容接口
		newsListFZ() {
			let params = {
				pageNum: this.pageNum,
				pageSize: 6,
				language: Number(this.lang === 'en')
			};
			getNewsList(params).then(res => {
				this.newsList = this.newsList.concat(res.rows);

				this.loading = false;
				if (res.total === 0) {
					this.totalpagenum = 1;
				} else {
					this.totalpagenum = Math.ceil(res.total / 6);
				}
				if (this.pageNum < this.totalpagenum) {
					this.pageNum++;
				} else {
					this.finished = true;
				}
			});
		},
		//查看详情
		Lookdetail(item) {
			localStorage.setItem('newsData', JSON.stringify(item));
			this.$router.push({
				name: 'Newscontent',
				query: {
					lang: this.lang,
					newsId: item.newsContentId
				}
			});
		}
	}
};
</script>

<style lang="scss">
@use './Newscenter.scss';
</style>
